import { render } from "./DataviewFiltersDropdowns.vue?vue&type=template&id=39b5ebb3"
import script from "./DataviewFiltersDropdowns.vue?vue&type=script&lang=js"
export * from "./DataviewFiltersDropdowns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__